<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" class="text-center">
        <h1>Willkommen bei der Bosseln-App!</h1>
        <p>Verwende das Menü, um zu den verschiedenen Seiten zu navigieren.</p>
        <v-btn block color="primary" @click="$router.push('/rules')">
          Zu den Regeln
        </v-btn>
        <v-btn block color="secondary" @click="checkAuthentication('/adhoc-game')">
          Ad-hoc-Spiel starten
        </v-btn>
        <v-btn block color="info" @click="checkAuthentication('/league')">
          Liga erstellen
        </v-btn>
      </v-col>
    </v-row>
  
    <v-dialog v-model="authModalVisible" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Anmeldung erforderlich</v-card-title>
        <v-card-text>
          <p>Bitte melde dich an oder registriere dich, um fortzufahren.</p>
          <v-btn color="primary" @click="$router.push('/login')">Anmelden</v-btn>
          <v-btn color="secondary" @click="$router.push('/register')">Registrieren</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "WelcomePage",
  data() {
    return {
      authModalVisible: false,
    };
  },
  methods: {
    checkAuthentication(route) {
      if (this.isAuthenticated()) {
        this.$router.push(route);
      } else {
        this.authModalVisible = true;
      }
    },
    isAuthenticated() {
      return localStorage.getItem('isAuthenticated') === 'true';
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}
p {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
}
</style>